import React from 'react'
import SharePage from '../components/ShareComponentMulti.jsx'

const Share = () => {
  return (
    <SharePage/>
  )
}

export default Share